var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"level-indicator",attrs:{"title":_vm.title}},[_c('div',{staticClass:"level-label"},[_vm._v(" Level ")]),_c('div',{staticClass:"level"},[_vm._v(" "+_vm._s(this.level)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }